var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFF1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 17.3134V18.6867C24.6667 19.0534 24.3734 19.3534 24.0001 19.3667H22.6934C21.9734 19.3667 21.3134 18.84 21.2534 18.12C21.2134 17.7 21.3734 17.3067 21.6534 17.0334C21.9001 16.78 22.2401 16.6334 22.6134 16.6334H24.0001C24.3734 16.6467 24.6667 16.9467 24.6667 17.3134Z",
    fill: "#E61B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6466 20.3666H22.6933C21.4266 20.3666 20.3599 19.4133 20.2533 18.2C20.1933 17.5066 20.4466 16.8133 20.9533 16.32C21.3799 15.88 21.9733 15.6333 22.6133 15.6333H23.6466C23.8399 15.6333 23.9999 15.4733 23.9799 15.28C23.8333 13.66 22.7599 12.5533 21.1666 12.3666C21.0066 12.34 20.8399 12.3333 20.6666 12.3333H14.6666C14.4799 12.3333 14.2999 12.3466 14.1266 12.3733C12.4266 12.5866 11.3333 13.8533 11.3333 15.6666V20.3333C11.3333 22.1733 12.8266 23.6666 14.6666 23.6666H20.6666C22.5333 23.6666 23.8199 22.5 23.9799 20.72C23.9999 20.5266 23.8399 20.3666 23.6466 20.3666ZM18.6666 16.5H14.6666C14.3933 16.5 14.1666 16.2733 14.1666 16C14.1666 15.7266 14.3933 15.5 14.6666 15.5H18.6666C18.9399 15.5 19.1666 15.7266 19.1666 16C19.1666 16.2733 18.9399 16.5 18.6666 16.5Z",
    fill: "#E61B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.b5e5a9e397db73583f12178ea54d32f0.svg";
export { ForwardRef as ReactComponent };